import React, { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Modal, Button } from "react-bootstrap";
import Stepper from "react-stepper-horizontal";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import AssignUserLocation from "./AssignUserLocation";
import DOMPurify from "dompurify";
import useAxios from "../../hooks/useAxios";
const CreateUser = ({ show, hide }) => {
  const [type, setType] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [showError, setShowError] = useState(false);
  const [isValidPassword, setIsValidPassword] = useState(false);
  const [showPasswordError, setShowPasswordError] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userFormData, setUserFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    emailAddress: "",
    username: "",
    password: "",
  });
  const [userId, setUserId] = useState();

  const user = JSON.parse(localStorage.getItem("user"));
  const queryClient = useQueryClient();
  const axiosInstance = useAxios();
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUserFormData((prevData) => ({
      ...prevData,
      [name]: DOMPurify.sanitize(value),
    }));
  };
  // Create user handler
  const createUser = (e) => {
    e.preventDefault();
    if (userFormData.password !== confirmPassword) {
      setShowError(true);
    } else {
      axiosInstance({
        url: "/users",
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.access_token}`,
        },
        data: userFormData,
      })
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            setActiveStep(1);
            setUserFormData({});
            setShowError(false);
            setConfirmPassword("");
            setUserId(res?.data.id);
            queryClient.invalidateQueries(["fetch-users"]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <div>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
      >
        <Modal.Header closeButton onClick={hide}>
          <h5>
            {activeStep === 0
              ? "Create User"
              : "Assign Location and group to a user"}
          </h5>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <Stepper
            steps={[
              { title: "Create User" },
              { title: "Assign Location and group" },
            ]}
            activeStep={activeStep}
          />
          {activeStep === 0 && (
            <form onSubmit={createUser}>
              <label className='ml-2'>FirstName</label>
              <input
                className='form-control input-field mb-2'
                placeholder='First name'
                name='firstName'
                onChange={handleInputChange}
                required
              />
              <label className='ml-2'>LastName</label>
              <input
                placeholder='Last Name'
                name='lastName'
                className='form-control input-field mb-2'
                onChange={handleInputChange}
                required
              />
              <label className='ml-2'>Phone Number</label>
              <input
                placeholder='Phone number'
                name='phoneNumber'
                className='form-control input-field mb-2'
                onChange={handleInputChange}
                required
              />
              <label className='ml-2'>Email Address</label>
              <input
                placeholder='Email Address'
                name='emailAddress'
                className='form-control input-field mb-2'
                onChange={handleInputChange}
              />
              <label className='ml-2'>Username</label>
              <input
                placeholder='Username'
                name='username'
                className='form-control input-field mb-2'
                onChange={handleInputChange}
                onKeyUp={() => setShowError(false)}
                required
              />
              {showError && (
                <span style={{ color: "red" }}>Password not Match</span>
              )}
              <div style={{ position: "relative" }}>
                <label className='ml-2'>Password</label>
                <input
                  placeholder='Password'
                  name='password'
                  type={showPassword ? "text" : "password"}
                  className='form-control input-field mb-2'
                  onChange={(e) => {
                    setUserFormData({
                      ...userFormData,
                      password: e.target.value,
                    });
                    // const isValidPassword =
                    //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!])[a-zA-Z\d@#$%^&+=!]{8,}$/.test(
                    //     e.target.value
                    //   );
                    // setIsValidPassword(isValidPassword);
                    // if (isValidPassword) {
                    //   setShowPasswordError(false);
                    // } else {
                    //   setShowPasswordError(true);
                    // }
                  }}
                  // onKeyUp={() => setShowError(false)}
                  required
                />
                {userFormData?.password?.length > 0 && (
                  <i
                    className='fa fa-eye'
                    aria-hidden='true'
                    style={{
                      position: "absolute",
                      right: 15,
                      bottom: 8,
                      cursor: "pointer",
                      fontSize: 20,
                      color: "#0000ff",
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                  />
                )}
              </div>
              {!isValidPassword &&
                showPasswordError &&
                userFormData?.password?.length > 0 && (
                  <>
                    <span style={{ color: "#8f250d" }}>
                      * Password should be at least 8 characters long
                    </span>
                    <br />
                    <span style={{ color: "#8f250d" }}>
                      * Mix of letters and numbers
                    </span>
                    <br />
                    <span style={{ color: "#8f250d" }}>
                      * Upper case and lower case
                    </span>
                    <br />
                    <span style={{ color: "#8f250d" }}>
                      * Special character(s)
                    </span>
                  </>
                )}
              <div style={{ position: "relative" }}>
                <label className='ml-2'>Confirm Password</label>
                <input
                  placeholder='Confirm Password'
                  type={type ? "text" : "password"}
                  className='form-control input-field mb-2'
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                {confirmPassword.length > 0 && (
                  <i
                    className='fa fa-eye'
                    aria-hidden='true'
                    style={{
                      position: "absolute",
                      right: 15,
                      bottom: 8,
                      cursor: "pointer",
                      fontSize: 20,
                      color: "#0000ff",
                    }}
                    onClick={() => setType(!type)}
                  />
                )}
              </div>
              <div className='d-flex justify-content-center'>
                <Button
                  // disabled={!isValidPassword}
                  className='custom-btn-color'
                  type='submit'
                >
                  Save & Continue
                </Button>
              </div>
            </form>
          )}
          {activeStep === 1 && (
            <AssignUserLocation
              hide={hide}
              setStep={setActiveStep}
              userId={userId}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CreateUser;
